<template>
  <nav class="burger-menu">
    <HeaderBurgerMenuList
      class="burger-menu__categories-list"
      @click-menu-item="emit('click-menu-item', $event)"
    />
  </nav>
</template>

<script lang="ts" setup>
  import HeaderBurgerMenuList from '~/components/TheHeader/Burger/HeaderBurgerMenuList.vue';

  const emit = defineEmits(['click-menu-item']);
</script>

<style lang="scss" scoped>
  @use '../styles/TheHeader.variables.scss' as *;
  @use '@devhacker/shared/styles/scrollbar.scss' as scrollbar;

  .burger-menu {
    background: $headerBg;
    color: $baseFont;
    height: 100%;
    padding-top: 0;

    overflow-y: auto;
    @include scrollbar.customScrollbar;

    @include tablet {
      border: 1px solid $headerActiveBurgerBorder;
      border-top: 0;
    }

    &__categories-list {
      height: 100%;

      > :deep() li {
        padding-bottom: $spacing-4;
        padding-top: $spacing-3;
      }
    }
  }

  .build-info {
    width: 100%;
  }
</style>
